/**
 * @author Qamar-ud-Din <m.qamaruddin@mQuBits.com>
 * Edited 
 * @author Mustafa Omran <promustafaomran@hotmail.com>
 */
import { Subject } from 'rxjs/Subject';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CartService {

  // Observable string sources
  public addItemSource = new Subject<string>();

  // Observable string streams
  public itemAddAnnounced$ = this.addItemSource.asObservable();

  constructor(
  ) {
    //
  }

  public insert(item: any) {
    let storedCart: string = localStorage.getItem('cart');
    let items = [];
    if (storedCart) {
      items = JSON.parse(localStorage.getItem('cart'));
    }

    if (!this.isInCart(item)) {
      item.qty = 1;
      items.push(item);
      localStorage.setItem('cart', JSON.stringify(items));
    }
  }

  public isInCart(item: any): Boolean {
    let storedCart: string = localStorage.getItem('cart');
    let items = [];
    if (storedCart) {
      items = JSON.parse(localStorage.getItem('cart'));
    }

    for (let storedItem of items) {
      if (storedItem.id === item.id) {
        return true;
      }
    }
    return false;
  }

  public editNotes(item: any, notes: any) {
    let storedCart: string = localStorage.getItem('cart');
    let items = [];
    if (storedCart) {
      items = JSON.parse(localStorage.getItem('cart'));
    }

    for (let storedItem of items) {
      if (storedItem.id === item.id) {
        storedItem.notes = notes;
      }
    }

    localStorage.setItem('cart', JSON.stringify(items));
  }

  public editCoupon(item: any, coupon: any) {
    let storedCart: string = localStorage.getItem('cart');
    let items = [];
    if (storedCart) {
      items = JSON.parse(localStorage.getItem('cart'));
    }

    for (let storedItem of items) {
      if (storedItem.url === item.url) {
        storedItem.coupon = coupon;
      }
    }

    localStorage.setItem('cart', JSON.stringify(items));
  }

  public remove(item: any) {
    let storedCart: string = localStorage.getItem('cart');
    let items = [];
    if (storedCart) {
      items = JSON.parse(localStorage.getItem('cart'));
    }

    let index = 0;
    for (let storedItem of items) {
      if (storedItem.url === item.url) {
        items.splice(index, 1);
        localStorage.setItem('cart', JSON.stringify(items));
        return;
      }
      ++index;
    }
  }

  public get() {
    let storedCart: string = localStorage.getItem('cart');
    let items = [];
    if (storedCart) {
      items = JSON.parse(localStorage.getItem('cart'));
    }
    return items;
  }

  public update(url, data) {
    //
  }

  // Service message commands
  public announceItemAdded(item: any) {
    this.insert(item);
    this.addItemSource.next(item);
  }

  public sumTotal(): number {
    let ret = 0;
    let storedCart: string = localStorage.getItem('cart');
    let items = [];
    if (storedCart) {
      items = JSON.parse(localStorage.getItem('cart'));
    }

    for (let item of items) {
      if (item.price) {
        ret += parseFloat(item.price);
      } else {
        this.remove(item);
      }
    }
    return Math.round(ret * 100) / 100;
  }

  public cartTotalItem(): number {
    let ret = 0;
    let storedCart: string = localStorage.getItem('cart');
    let items = [];

    if (storedCart) {
      items = JSON.parse(localStorage.getItem('cart'));
    }

    return items.length;
  }

  public clear() {
    localStorage.removeItem('cart');
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/MartMax/services/cart/cart.service.ts